<template>
  <div>
    <button class="p-1" @click="show = true">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4 text-gray-600 inline-block"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
        />
      </svg>
    </button>

    <Portal v-if="show" to="app-dialog">
      <EditContactNameFormModal
        :action="updateContact"
        :default-data="defaultFormData"
        @close="show = false"
      />
    </Portal>
  </div>
</template>

<script>
import EditContactNameFormModal from './EditContactNameFormModal.vue';

export default {
  inject: ['updateContact'],
  components: {
    EditContactNameFormModal,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId] || null;
    },
    defaultFormData() {
      const { firstName = '', lastName = '' } = this.contact || {};

      return { firstName, lastName };
    },
  },
};
</script>
